import React from 'react';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';

import MDBox from 'components/MDBox';

import PayrollSettingsHeaderMini from './PayrollSettingsHeaderMini';
import PayrollSettingsFormMini from './PayrollSettingsFormMini';

export default function PayrollSettingsStrip({
  staff,
  value,
  onChange,
  onOpenPricingModal,
  lessonRuleCount,
  packageRuleCount,
}) {
  return (
    <Card
      sx={{
        borderRadius: '22px',
        border: '1px solid rgba(15,23,42,0.08)',
        boxShadow: 'none',
        overflow: 'hidden',
        background: 'linear-gradient(180deg, rgba(248,250,252,0.96), rgba(255,255,255,0.98))',
      }}
    >
      <MDBox sx={{ px: { xs: 1.2, md: 1.5 }, py: { xs: 1.1, md: 1.2 } }}>
        <PayrollSettingsHeaderMini staff={staff} value={value} />
      </MDBox>

      <Divider />

      <MDBox sx={{ px: { xs: 1.2, md: 1.5 }, py: { xs: 1.2, md: 1.35 } }}>
        <PayrollSettingsFormMini
          value={value}
          onChange={onChange}
          onOpenPricingModal={onOpenPricingModal}
          lessonRuleCount={lessonRuleCount}
          packageRuleCount={packageRuleCount}
        />
      </MDBox>
    </Card>
  );
}
